// eslint-disable-next-line import/prefer-default-export
import config from "../config";

export const UPDATE_EMPLOYER_TYPE = "UPDATE_EMPLOYER_TYPE";
export const JOB_APPLICANT_PAGE_SIZE = config?.env === "production" ? 30 : 5; // may change in the future.
export const JOB_APPLICANT_DOWNLOAD_PAGE_SIZE = config?.env === "production" ? 200 : 5; // may change in the future.
export const ATS_JOB_APPLICANT_PAGE_SIZE = 1000;
export const JOB_APPLICANT_DOWNLOAD_PAGE_SIZE_MAX_LIMIT =
	config?.env === "production" ? 50 : 1;
